module.exports = __webpack_public_path__ + "static/media/side_arrow.1cc966ba.svg";